import React from 'react'
import { CONTENTFUL_TYPES, ContentfulKey } from 'parameters/index'
import { ContentfulItems } from 'types/contentful'
import { useContentfulResourcesMapped } from 'stores/Contentful/hooks'
import { ContentfulLogger } from 'services/Logger'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

export interface InjectedContentfulProps {
	getValue(contentfulItem: ContentfulKey): any
}

type ContentfulHoc = <P>(
	Component: React.ComponentType<React.PropsWithChildren<P & InjectedContentfulProps>>
) => React.ComponentType<React.PropsWithChildren<P>>

/**
 * @deprecated
 * @param Component
 */
export const withContentful: ContentfulHoc =
	Component =>
	// eslint-disable-next-line sonarjs/cognitive-complexity
	props => {
		const contentfulState = useContentfulResourcesMapped()
		const getValue = (contentfulItem: ContentfulKey): ContentfulItems => {
			try {
				let resource

				if (contentfulItem.GROUP_KEY) {
					const group = contentfulState[contentfulItem.GROUP_KEY]
					if (group?.contentType === 'resourceGroup') {
						resource = group.resourceGroup.resources.find(item => item.key === contentfulItem.KEY)
					}
				} else {
					const single = contentfulState[contentfulItem.KEY]
					if (single?.contentType === 'resource') {
						resource = single.resource
					}
				}

				if (!resource) {
					ContentfulLogger.warn('Resource not found', contentfulItem)
					return ''
				}

				let returnValue
				switch (contentfulItem.TYPE) {
					case CONTENTFUL_TYPES.MEDIA_VALUE:
						const title = resource.textValue
						const asset = resource.mediaValue
						returnValue = asset ? { title, asset, url: asset.url } : undefined
						break

					case CONTENTFUL_TYPES.RICH_TEXT_VALUE:
						returnValue = resource.richTextValue ? documentToReactComponents(resource.richTextValue) : []
						break

					default:
					case CONTENTFUL_TYPES.VALUE:
						returnValue = resource.textValue
						break
				}
				if (returnValue) return returnValue
				ContentfulLogger.warn('Resource not correct', contentfulItem)
				return ''
			} catch (err) {
				console.error(err)
				return ''
			}
		}

		return <Component {...props} getValue={getValue} />
	}
